var React = require('react');
var css = require('./table.scss');
/**
 * <TableFixedHead data={this.state.table} initHeight={200}/>
 * table: {
    struct: [
        { title: '手机号码', key: function(d) {
            return <a>{d.phone}</a>;
        }, width: 200 },            // 一定要给宽度，否则不对齐
        { title: '备注', key: 'remark', width: 200 },
        { title: '更新时间', key: 'time' }
    ],
    data: [
        { phone: '13111111111', remark: '123', time: '2018-01-01' },
        { phone: '13122222222', remark: '456', time: '2018-02-02' },
        { phone: '13133333333', remark: '789', time: '2018-03-03' },
        { phone: '13144444444', remark: '000', time: '2018-04-04' }
    ],
    stripe: true
 *
 * 注：列的宽度和不能大于表格的宽度，最后一列可以不设置宽度
 */

var TableFixedHead = React.createClass({
    render: function() {
        var cls = ['fp-table-fixed-head'];
        var data = this.props.data;
        var rowStyle = this.props.rowStyle;
        var style = {};
        var colGroups = [];
        data.struct.map((o, i) => {
            if (o.hidden == "true"){
                return ;
            }
            colGroups.push(<col width = {o.width || this.props.minWidth}></col>);
        });
        return <div className={cls.join(' ')}  style={this.props.style || {}}>
            <table className='fp-table fp-head-table'>
                <colgroup>{colGroups}</colgroup>
                {
                    data.tableHead != null &&
                    <thead>
                    {
                        Array.isArray(data.tableHead)&&
                        data.tableHead.map((o, i)=> {
                            return <tr className={cls.join(' ')} data-index={ i }
                                       style={rowStyle && rowStyle[i] ? rowStyle[i] : {}}>
                                {
                                    o.map(function(th, index) {
                                        return th;
                                    })
                                }
                            </tr>;
                        })
                    }

                    </thead>
                }
                {
                    data.tableHead != null && !Array.isArray(data.tableHead) &&
                    data.tableHead
                }
                {
                    data.tableHead == null &&
                    <thead>
                       <tr style={rowStyle && rowStyle[0] ? rowStyle[0] : {}}>
                            {
                                data.struct.map((o, i) => {
                                if (o.hidden == "true"){
                                    return ;
                                }
                                return <th className={o.className || ''}>
                            {
                                typeof o.title === 'function' ? o.title.call(this, o, i) : o.title
                            }
                                </th>;
                            })
                            }
                        </tr>
                    </thead>
                }
            </table>
            <div className="fp-table-content-wrap" style={{
                height: this.props.initHeight,
                'overflow-y': this.props.initHeight ? 'auto' : 'visible'
            }}>
                <table className='fp-table fp-table-fixed-head-body'>
                    <colgroup>{colGroups}</colgroup>
                    <tbody>
                        {
                            data.data.length ? data.data.map(function(o, i) {
                                var cls = [];
                                if (this.props.data.stripe && i % 2) {
                                    cls.push('fp-stripe');
                                }
                                if (i == data.data.length - 1) {
                                    cls.push('fp-table-last-tr');
                                }
                                var inx =  data.tableHead != null ? data.tableHead.length:1;

                                return <tr className={cls.join(' ')} data-index={ i }
                                    style={rowStyle && rowStyle[i + inx] ? rowStyle[i + inx] : {}}>
                                    {
                                        data.struct.map(function(p, index) {
                                            if (p.hidden == "true"){
                                                return ;
                                            }
                                            return <td className={p.className || ''}>
                                                {typeof p.key == 'function' ? p.key.call(this, o, i, index, p) : o[p.key]}
                                            </td>;
                                        }.bind(this))
                                    }
                                </tr>;
                            }.bind(this))
                                : <tr>
                                    <td colSpan={data.struct.length} style={{
                                        width: '100%',
                                        "border-bottom": 0
                                    }}>
                                        {
                                            this.props.isFixedLeft || this.props.isFixedRight
                                                ? '-'
                                                : this.props.emptyText || '未查询到数据'
                                        }

                                    </td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>;
    }
});

module.exports = TableFixedHead;



// WEBPACK FOOTER //
// ./component/table/tableFixedHead.js